import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import ListedAddressFilter from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/ListedAddressFilter/ListedAddressFilter";
import ListedAddressFilterResult from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/ListedAddressFilter/ListedAddressFilterResult";
import FindListedAddressFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/ListedAddressFilter/ListedAddressFilter";
import type { IAppsCommonFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";
import settingsService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/sw-settings/settingsService";
import type { ICountryObject } from "app/services/CountryService";
import { US_COUNTRY_ID } from "app/services/countryServiceConst";

const createListedAddressFilter = (): IFilterInstance<IAppsCommonFiltersDto> => {
    const allCountries: ICountryObject[] = settingsService
        .getCompanyInformationCountries()
        .filter((c) => c.parent !== US_COUNTRY_ID);

    return {
        key: "listedAddress",
        trackingName: "App Listed Address",
        title: { key: "si.find_apps.filters.listed-address.title" },
        tooltipText: { key: "si.find_apps.filters.listed-address.tooltip" },
        filter: new FindListedAddressFilter({
            options: allCountries,
        }),
        filterView: ListedAddressFilter,
        filterResultView: ListedAddressFilterResult,
    };
};

export default createListedAddressFilter;
